import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveRedEyeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_red_eye"}/>
}
